"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.numericalTypes = exports.categoricalTypes = void 0;
var catTypesCassandra = ['INT', 'BIGINT', 'TEXT'];
var catTypesParquetS3 = ['LONG', 'STRING'];
exports.categoricalTypes = __spreadArray(__spreadArray([], catTypesCassandra, true), catTypesParquetS3, true);
var numTypesCassandra = ['INT', 'DOUBLE'];
var numTypesParquetS3 = [];
exports.numericalTypes = __spreadArray(__spreadArray([], numTypesCassandra, true), numTypesParquetS3, true);
//# sourceMappingURL=dataTypes.js.map